import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import {useHttpMonitorDelete} from 'features/http/model/useHttpMonitorMutations';

interface HttpMonitorModuleDeleteProps {
    item: IHttpMonitorOutput,
    open: boolean;
    handleClose: () => void;
}

const HttpMonitorDeleteModal: React.FC<HttpMonitorModuleDeleteProps> = ({ item, open, handleClose }) => {
    const {remove, isLoading} = useHttpMonitorDelete({item, handleClose});

    return (
        <ConfirmModal
            variant="delete"
            open={open}
            handleClose={handleClose}
            header={t`Удаление монитора`}
            title={<Trans id="modal.monitor.delete.title" message="Вы уверены, что хотите удалить монитор"/>}
            name={item.name || item.url}
            confirmText={t`Удалить`}
            onConfirm={remove}
            isLoading={isLoading}
        />
    );
};

export default HttpMonitorDeleteModal;
